<template>
  <section>
    <b-badge v-for="collection in product.collections" :key="collection.id" variant="secondary" class="mx-1" itemprop="isRelatedTo">
      {{ collection.name }}
    </b-badge>
  </section>
</template>

<script>
export default {
  name: 'ProductCollections',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
